import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=28036950"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"
import style0 from "./Invite.vue?vue&type=style&index=0&id=28036950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports